module.exports = "\n<!-- Optional (custom login) -->\n\n\n"